// Override
var GetExpandedChildWidth = function (child, parentWidth) {
    return parentWidth;
}

export default GetExpandedChildWidth;